<template>
  <div class="healthcarepayC_main">
    <ball></ball>
    <div class="healthcarepayC_head">
      <div class="head_cell">
        <div>
          <div class="head_text1">付款给</div>
          <div class="head_text2">{{ hospName }}</div>
        </div>
        <div>
          <van-image
            class="head_img"
            width="40"
            height="40"
            :src="require('@/assets/hpayicon.png')"
          />
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '70%' }">
      <div class="healthcarepayC_pop">
        <div class="pop_title">
          <div>处方明细</div>
          <div><van-icon name="cross" @click="show = false" /></div>
        </div>
        <div class="popcard">
          <div class="popcard_title">
            <div class="title_color"></div>
            就诊信息
          </div>

          <div class="popcard_cell">
            <div>门诊科室</div>
            <div>{{ siPreInfo.deptName }}</div>
          </div>
          <div class="popcard_cell">
            <div>医生姓名</div>
            <div>{{ siPreInfo.drName }}</div>
          </div>

          <div class="popcard_cell">
            <div>费用总额</div>
            <div style="color: #96aff4; font-weight: 600">
              {{ siPreInfo.feeSumamt | regFenToYuan }}元
            </div>
          </div>
        </div>

        <div class="popcard">
          <div class="popcard_title">
            <div class="title_color"></div>
            诊断信息
          </div>
          <div class="popcard_cell">
            <div>诊断名称</div>
            <div>{{ siPreInfo.diagNmae }}</div>
          </div>
          <div class="popcard_cell">
            <div>诊断编号</div>
            <div>{{ siPreInfo.diagCode }}</div>
          </div>
        </div>
        <div class="popcard">
          <div class="popcard_title">
            <div class="title_color"></div>
            费用信息
          </div>
          <div
            class="popcard_cell"
            v-for="(item, index) in OutfeeList"
            :key="index"
          >
            <div>{{ item.medListName }}*{{ item.medListSpc }}</div>
            <div>{{ item.detItemFeeSumamt }}</div>
          </div>
        </div>
      </div>
    </van-popup>
    <div class="healthcarepayC_body">
      <div class="body_card">
        <div class="card_head">
          <div>费用总额</div>
          <div>{{ siPreInfo.feeSumamt | regFenToYuan }}元</div>
        </div>
        <div class="card_cell">
          <div>医保基金支付</div>
          <div>{{ siPreInfo.fundPay | regFenToYuan }}元</div>
        </div>
        <div class="card_cell">
          <div>个人账户支付</div>
          <div>{{ siPreInfo.psnAcctPay | regFenToYuan }}元</div>
        </div>
        <div class="card_cell">
          <div>其他抵扣金额</div>
          <div>0元</div>
        </div>
        <div class="card_cell" style="margin-top: 1vh">
          <div style="color: #5078ea; font-size: 18px; font-weight: 600">
            现金支付
          </div>
          <div style="color: #5078ea; font-size: 18px; font-weight: 600">
            {{ siPreInfo.ownPayAmt | regFenToYuan }}元
          </div>
        </div>
        <div class="card_foot" @click="show = true">查看明细</div>
      </div>
      <div class="body_text">
        <div class="text_text">
          <van-image
            class="head_img"
            width="40"
            height="14"
            :src="require('@/assets/yibaoicon.png')"
          />
          <span
            style="
              color: #a6a7ad;
              margin-left: 2vw;
              width: 80px;
              font-size: 15px;
            "
            >医保移动支付</span
          >
        </div>
      </div>
    </div>
    <div class="healthcarepayC_foot">
      <div class="foot_left">
        您还需支付：<span
          style="color: #4972e9; font-weight: 700; font-size: 20px"
          >￥{{ siPreInfo.ownPayAmt | regFenToYuan }}元</span
        >
      </div>

      <div class="foot_right">
        <van-button type="info" round @click="goPay()">去支付</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      show: false,
      //就诊人卡号
      clientId: "",
      checked: false,
      //流水号
      registerId: "",
      //名字
      name: "",
      //总金额
      authCode: "",
      retCode: "",
      payurl: "",
      show: false,
      ClinetName: "",
      OutfeeList: [],
      siPreInfo: null,
      iIPID: null,
      code: null,
      pay_url: null,
      hospName: "",
      reginfo:null
    };
  },
  mounted() {
    this.recipes = this.$route.query.recipes;
    this.clientId = this.$route.query.sSIID;
    this.iIPID = this.$route.query.iIPID;
    this.name = this.$route.query.name;
    this.code = this.$route.query.authCode;
    this.retCode = this.$route.query.retCode;
    if (this.retCode != "0") {
      this.$router.push(
        `/pay_list_D?clientId=${this.clientId}&flag=2&name=${this.name}`
      );
      return;
    }
    if (this.$route.query.reginfo) {
     this.reginfo=this.$route.query.reginfo;
     this.getreginfo();
      return;
    }
    this.getpayinfo();
  },
  filters: {
    FinalPrice(price) {
      return Number(price).toFixed(2);
      // console.log(price);
    },
    regFenToYuan(fen) {
      let yuan = Number(fen) * 0.01;
      return yuan.toFixed(2);
    },
  },
  methods: {
    async goPay() {
      window.location.href = this.pay_url;
    },
    async getpayinfo() {
      //请求医院信息:""
      // 医院的名字、地址、banner图片、图标、功能
      let data = {
        recipes: this.recipes,
        clientId: this.clientId,
        iIPID: this.iIPID,
        code: this.code,
        name: this.name,
      };
      try {
        this.$showLoad();
        this.isLoad = true;
        let url = "/outpatientfee/Dhcarepay";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "post",
          data,
          (data) => {
            this.$hideLoad();
            if (data.status != 200) {
              this.$router.push(
                `/pay_list_D?clientId=${this.clientId}&flag=2&name=${this.name}`
              );
            } else {
              let hcarepayinfo = data.data.result.hcarepayinfo;
              let MUPAppPay = data.data.result.MUPAppPay;
              this.hospName = data.data.result.hospName;
              if (!Array.isArray(MUPAppPay.data.ItemList.Item)) {
                var item = MUPAppPay.data.ItemList.Item;
                this.OutfeeList.push(item);
              } else {
                this.OutfeeList = MUPAppPay.data.ItemList.Item;
              }
              this.siPreInfo = MUPAppPay.data;
              this.pay_url = hcarepayinfo.pay_url;
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },

    async getreginfo() {
      //请求医院信息:""
      // 医院的名字、地址、banner图片、图标、功能
      let info=JSON.parse(this.reginfo);
      let data = {
       ...info,
       code: this.code,
      };
      try {
        this.$showLoad();
        this.isLoad = true;
        let url = "/outpatientfee/SiregisterPayCommitC";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "post",
          data,
          (data) => {
            this.$hideLoad();
            if (data.status != 200) {
              this.$router.push(
                `/pay_list_D?clientId=${this.clientId}&flag=2&name=${this.name}`
              );
            } else {
              let hcarepayinfo = data.data.result.hcarepayinfo;
              let MUPAppPay = data.data.result.MUPAppPay;
              this.hospName = data.data.result.hospName;
              if (!Array.isArray(MUPAppPay.data.ItemList.Item)) {
                var item = MUPAppPay.data.ItemList.Item;
                this.OutfeeList.push(item);
              } else {
                this.OutfeeList = MUPAppPay.data.ItemList.Item;
              }
              this.siPreInfo = MUPAppPay.data;
              this.pay_url = hcarepayinfo.pay_url;
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.healthcarepayC_main {
  font-family: PingFang SC;
  height: 100vh;
  width: 100%;

  .healthcarepayC_head {
    background-color: #4972e9;
    height: 20vh;
    border-radius: 0 0 40px 40px;
    padding: 25px;
    .head_cell {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 8vh;
      .head_text1 {
        color: #a5baf4;
        font-size: 15px;
      }
      .head_text2 {
        margin-top: 4px;
        color: #fff;
      }
      .head_img {
        margin-top: 2vh;
      }
    }
  }
  .healthcarepayC_pop {
    padding: 15px;
    width: 100vw;
    .pop_title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 18px;
      font-weight: 600;
      line-height: 8vh;
    }
    .popcard {
      border: 2px solid #e6e6e6;
      border-radius: 8px;
      width: 93vw;
      margin: 0px auto;
      padding: 10px 0px;
      margin-bottom: 2vh;
      .popcard_title {
        line-height: 6vh;
        border-bottom: 1px solid #e6e6e6;
        display: flex;
        flex-direction: row;
        .title_color {
          width: 3px;
          height: 18px;
          background-color: #4972ec;
          align-self: center;
          justify-items: center;
          margin-left: 5px;
          margin-right: 10px;
        }
      }
      .popcard_cell {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0px 15px;
        margin-top: 1vh;
        font-size: 16px;
        color: #9d9da0;
      }
    }
  }
  .healthcarepayC_body {
    height: 76vh;
    .body_card {
      width: 92vw;
      background: #ffffff;
      border: 1px solid #e6e6e6;
      box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.100825);
      border-radius: 16px;
      margin: 0 auto;
      margin-top: -7vh;
      padding: 15px 15px 0px 15px;
      .card_head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        line-height: 8vh;
        font-weight: 600;
        font-size: 18px;
        border-bottom: 1px dashed #f1f1f1;
        margin-bottom: 2vh;
      }
      .card_cell {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        line-height: 4vh;
        font-size: 16px;
        margin-bottom: 3px;
        color: #bfc0c3;
      }
      .card_foot {
        border-top: 1px dashed #f1f1f1;
        text-align: center;
        height: 8vh;
        line-height: 8vh;
      }
    }
    .body_text {
      width: 100%;
      margin-top: 3vh;
      text-align: center;
    }
  }
  .healthcarepayC_foot {
    height: 10vh;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 10vh;
    font-size: 16px;
    border-top: 1px solid #f1f1f1;
    .foot_left {
      margin-left: 2vw;
    }
    .foot_right {
      margin-right: 2vw;
    }
  }
}
</style>